import { apiClient } from './client';

export type TrialState = 'none' | 'never_used' | 'active' | 'expired';

export type IssueSeverity = 'warning' | 'critical';

export interface AdminOrgIssue {
  code: string;
  severity: IssueSeverity;
  message: string;
}

export interface AdminOrgListItem {
  id: string;
  name: string;
  code: string;
  type: string;
  is_active: boolean;
  is_demo: boolean;

  subscription_tier: string;
  effective_tier: string;
  trial_tier: string | null;
  trial_ends_at: string | null;
  trial_used: boolean;
  trial_state: TrialState;
  trial_days_remaining: number | null;

  user_count: number;
  last_activity_at: string | null;

  created_date: string;
  issues: AdminOrgIssue[];
}

export interface AdminOrgsListParams {
  search?: string;
  tier?: string;
  trial_state?: TrialState;
  has_issues?: boolean;
  skip?: number;
  limit?: number;
}

const BASE_URL = '/admin/orgs';

export const adminOrgsApi = {
  async list(params?: AdminOrgsListParams): Promise<AdminOrgListItem[]> {
    const response = await apiClient.get(BASE_URL, { params });
    return response.data;
  },
};
